import { from, map } from 'rxjs';
import AwardsResult from '@/awards/models/AwardsResult';
import AwardsData from '@/awards/models/AwardsData';
import LeaderboardResult from '@/awards/models/leaderboards/LeaderboardResult';
import Leaderboard from '@/awards/models/leaderboards/Leaderboard';
import ClientFilterStore from '../models/filters/client/ClientFilterStore';

class AwardsClient {
  /**
   *
   * @type {AxiosInstance}
   */
  http = null;

  resultsEndpoint = 'v2/awards/results';

  filtersEndpoint = 'v2/awards/filters';

  /**
   *
   * @param httpClient{AxiosInstance}
   */
  constructor(httpClient) {
    this.http = httpClient;
  }

  /**
   *
   * @param indexId
   * @returns {Observable<AwardsResult>}
   */
  getAwardsDataObservable(indexId, awardResultType) {
    const url = 'getAwardsData';
    const params = {
      deploymentIndexId: indexId,
      awardResultType: awardResultType,
    };

    const awardsObservable = from(this.http.get(url, { params }))
      .pipe(map(({ data }) => new AwardsResult(data)));

    return awardsObservable;
  }

  /**
   *
   * @param indexId{int}
   * @param selectedFilters{Object}
   * @returns {Observable<Observable<RegionTally>[]>}
   */
  getFilteredData(indexId, selectedFilters, awardResultType) {
    const url = 'getFilteredAwardsData';
    const postData = {
      currentFilterValues: selectedFilters,
    };

    const params = {
      deploymentIndexId: indexId,
      awardResultType: awardResultType,
    };

    const observables = from(this.http.post(url, postData, { params }))
      .pipe(map(({ data }) => new AwardsResult(data)));

    return observables;
  }

  /**
   *
   * @param indexId
   * @returns {Observable<LeaderboardResult>}
   */
  getLeaderboardObservable(indexId) {
    const url = 'getAwardsLeaderboard';
    const params = {
      deploymentIndexId: indexId,
    };

    const awardsObservable = from(this.http.get(url, { params }))
      .pipe(map(({ data }) => new LeaderboardResult(data)));

    return awardsObservable;
  }

  /**
   *
   * @param indexId{number}
   * @param selectedFilters{Object}
   * @param league{Leagues}
   * @returns {Observable<Leaderboard>}
   */
  getFilteredLeaderboard(indexId, selectedFilters, league) {
    const url = 'getFilteredAwardsLeaderboard';

    const postData = {
      currentFilterValues: selectedFilters,
      selectedLeaderboardLeague: league,
    };

    const params = {
      deploymentIndexId: indexId,
    };

    const observables = from(this.http.post(url, postData, { params }))
      .pipe(map(({ data }) => Leaderboard.build(data.leaderboardData)));

    return observables;
  }

  getAwardResultsDataObservable(indexId, awardResultType) {
    const url = `${this.resultsEndpoint}/${awardResultType}`;
    const params = {
      deploymentIndexId: indexId,
    };

    const awardsObservable = from(this.http.get(url, { params }))
      .pipe(map(({ data }) => new AwardsResult(data)));

    return awardsObservable;
  }

  getFilteredAwardResults(indexId, selectedFilters, awardResultType) {
    const url = `${this.resultsEndpoint}/${awardResultType}`;
    const postData = {
      deploymentIndexId: indexId,
      setFieldValueIds: selectedFilters,
    };

    const observables = from(this.http.post(url, postData))
      .pipe(map(({ data }) => new AwardsResult(data)));

    return observables;
  }

  getAwardFiltersObservable(indexId, selectedFilters, filterType) {
    // const url = `${this.filtersEndpoint}`;
    const url = `v2/${filterType}/filters`;
    const postData = {
      deploymentIndexId: indexId,
      setFieldValueIds: selectedFilters,
    };

    const filtersObservable = from(this.http.post(url, postData))
      .pipe(map(({ data }) => new ClientFilterStore(data)));

    return filtersObservable;
  }

  getLeaderboardResults(indexId) {
    const url = `${this.resultsEndpoint}/leaderboard`;
    const params = {
      deploymentIndexId: indexId,
    };

    const awardsObservable = from(this.http.get(url, { params }))
      .pipe(map(({ data }) => Leaderboard.build(data.leaderboardData)));

    return awardsObservable;
  }
  
  getFilteredLeaderboardResults(indexId, selectedFilters) {
    const url = `${this.resultsEndpoint}/leaderboard`;
    const postData = {
      deploymentIndexId: indexId,
      setFieldValueIds: selectedFilters,
    };

    const observables = from(this.http.post(url, postData))
      .pipe(map(({ data }) => Leaderboard.build(data.leaderboardData)));

    return observables;
  }
}

export default AwardsClient;
